import React, { JSX } from 'react'

/**
 * 改行コード（\n）を JSX の改行要素（<br />）に変換します。
 *
 * 与えられた文字列を `\n` で分割し、各行を React.Fragment で囲みつつ
 * 行末に `<br />` を挿入して返します。
 *
 * @param text - 改行を含む文字列
 * @returns 改行に対応した JSX の配列
 */
export const convertToLineBreaks = (text: string): (string | JSX.Element)[] => {
  return text.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index !== text.split('\n').length - 1 && <br />}
    </React.Fragment>
  ))
}
